export const localization_en = {
  'inbox.filters.dropdownOptions.unread': 'Unread only',
  'inbox.filters.dropdownOptions.default': 'Unread & read',
  'inbox.filters.dropdownOptions.archived': 'Archived',
  'inbox.filters.dropdownOptions.snoozed': 'Snoozed',
  'inbox.filters.labels.unread': 'Unread',
  'inbox.filters.labels.default': 'Inbox',
  'inbox.filters.labels.archived': 'Archived',
  'inbox.filters.labels.snoozed': 'Snoozed',

  'notifications.emptyNotice': 'Quiet for now. Check back later.',
  'notifications.actions.readAll': 'Mark all as read',
  'notifications.actions.archiveAll': 'Archive all',
  'notifications.actions.archiveRead': 'Archive read',
  'notifications.newNotifications': ({
    notificationCount,
  }: {
    notificationCount: number;
  }) => `${notificationCount} new notification(s)`,

  'notification.actions.read.tooltip': 'Mark as read',
  'notification.actions.unread.tooltip': 'Mark as unread',
  'notification.actions.archive.tooltip': 'Archive',
  'notification.actions.unarchive.tooltip': 'Unarchive',
  'notification.actions.snooze.tooltip': 'Snooze',
  'notification.actions.unsnooze.tooltip': 'Unsnooze',

  'notification.snoozedUntil': 'Snoozed until',
  'preferences.title': 'Preferences',
  'preferences.emptyNotice': 'No notification specific preferences yet.',
  'preferences.global': 'Global Preferences',
  'preferences.schedule.title': 'Schedule',
  'preferences.schedule.description': 'Allow notifications between:',
  'preferences.schedule.headerInfo':
    'Set your schedule. Notifications to external channels will pause outside the schedule. In-app and critical notifications are always delivered.',
  'preferences.schedule.info':
    'Critical and In-app notifications still reach you outside your schedule.',
  'preferences.schedule.days': 'Days',
  'preferences.schedule.from': 'From',
  'preferences.schedule.to': 'To',
  'preferences.schedule.copyTimesTo': 'Copy times to',
  'preferences.schedule.sunday': 'Sunday',
  'preferences.schedule.monday': 'Monday',
  'preferences.schedule.tuesday': 'Tuesday',
  'preferences.schedule.wednesday': 'Wednesday',
  'preferences.schedule.thursday': 'Thursday',
  'preferences.schedule.friday': 'Friday',
  'preferences.schedule.saturday': 'Saturday',
  'preferences.schedule.dayScheduleCopy.title': 'Copy times to:',
  'preferences.schedule.dayScheduleCopy.selectAll': 'Select all',
  'preferences.schedule.dayScheduleCopy.apply': 'Apply',
  'preferences.workflow.disabled.notice':
    'Contact admin to enable subscription management for this critical notification.',
  'preferences.workflow.disabled.tooltip': 'Contact admin to edit',
  'preferences.group.info': 'Applies to all notifications under this group.',
  'snooze.datePicker.timePickerLabel': 'Time',
  'snooze.datePicker.apply': 'Apply',
  'snooze.datePicker.cancel': 'Cancel',

  'snooze.options.anHourFromNow': 'An hour from now',
  'snooze.options.inOneDay': 'Tomorrow',
  'snooze.options.inOneWeek': 'Next week',
  'snooze.options.customTime': 'Custom time...',
  'snooze.datePicker.pastDateTooltip':
    'Selected time must be at least 3 minutes in the future',
  'snooze.datePicker.noDateSelectedTooltip': 'Please select a date',
  'snooze.datePicker.exceedingLimitTooltip': ({ days }: { days: number }) =>
    `Selected time cannot exceed ${days === 1 ? '24 hours' : `${days} days`} from now`,

  'subscription.subscribe': 'Subscribe',
  'subscription.unsubscribe': 'Unsubscribe',
  'subscription.preferences.header': 'Manage subscription',
  'subscription.preferences.headerInfo':
    'Manage which updates you’d like to receive. Note: Workflow and global settings control delivery and take precedence when disabled.',
  'subscription.preferences.notSubscribed.header': 'You’re not subscribed.',
  'subscription.preferences.notSubscribed.description':
    'Subscribe to receive updates on new activity.',
  'subscription.preferences.empty.header': 'You’re subscribed.',
  'subscription.preferences.empty.description': 'Nothing to manage right now.',
};

export const localization_hu = {
  'inbox.filters.dropdownOptions.unread': 'Csak olvasatlan',
  'inbox.filters.dropdownOptions.default': 'Olvasatlan és olvasott',
  'inbox.filters.dropdownOptions.archived': 'Archivált',
  'inbox.filters.dropdownOptions.snoozed': 'Elhalasztott',
  'inbox.filters.labels.unread': 'Olvasatlan',
  'inbox.filters.labels.default': 'Beérkezett üzenetek',
  'inbox.filters.labels.archived': 'Archivált',
  'inbox.filters.labels.snoozed': 'Elhalasztott',

  'notifications.emptyNotice': 'Most csend van. Nézz vissza később.',
  'notifications.actions.readAll': 'Összes megjelölése olvasottként',
  'notifications.actions.archiveAll': 'Összes archiválása',
  'notifications.actions.archiveRead': 'Olvasottak archiválása',
  'notifications.newNotifications': ({
    notificationCount,
  }: {
    notificationCount: number;
  }) => `${notificationCount} új értesítés`,

  'notification.actions.read.tooltip': 'Megjelölés olvasottként',
  'notification.actions.unread.tooltip': 'Megjelölés olvasatlanként',
  'notification.actions.archive.tooltip': 'Archiválás',
  'notification.actions.unarchive.tooltip': 'Archiválás visszavonása',
  'notification.actions.snooze.tooltip': 'Elhalasztás',
  'notification.actions.unsnooze.tooltip': 'Elhalasztás visszavonása',

  'notification.snoozedUntil': 'Elhalasztva eddig:',
  'preferences.title': 'Beállítások',
  'preferences.emptyNotice': 'Még nincsenek értesítés-specifikus beállítások.',
  'preferences.global': 'Általános beállítások',
  'preferences.schedule.title': 'Ütemezés',
  'preferences.schedule.description':
    'Értesítések engedélyezése ezen időszakban:',
  'preferences.schedule.headerInfo':
    'Állítsa be az ütemezést. A külső csatornákra küldött értesítések szünetelnek az ütemezésen kívül. Az alkalmazáson belüli és kritikus értesítések mindig kézbesítésre kerülnek.',
  'preferences.schedule.info':
    'A kritikus és alkalmazáson belüli értesítések az ütemezésen kívül is elérnek.',
  'preferences.schedule.days': 'Napok',
  'preferences.schedule.from': 'Ettől',
  'preferences.schedule.to': 'Eddig',
  'preferences.schedule.copyTimesTo': 'Időpontok másolása ide:',
  'preferences.schedule.sunday': 'Vasárnap',
  'preferences.schedule.monday': 'Hétfő',
  'preferences.schedule.tuesday': 'Kedd',
  'preferences.schedule.wednesday': 'Szerda',
  'preferences.schedule.thursday': 'Csütörtök',
  'preferences.schedule.friday': 'Péntek',
  'preferences.schedule.saturday': 'Szombat',
  'preferences.schedule.dayScheduleCopy.title': 'Időpontok másolása ide:',
  'preferences.schedule.dayScheduleCopy.selectAll': 'Összes kijelölése',
  'preferences.schedule.dayScheduleCopy.apply': 'Alkalmazás',

  'preferences.workflow.disabled.notice':
    'Lépjen kapcsolatba az adminisztrátorral a kritikus értesítés feliratkozási kezelésének engedélyezéséhez.',
  'preferences.workflow.disabled.tooltip':
    'Szerkesztéshez lépjen kapcsolatba az adminisztrátorral',
  'preferences.group.info': 'A csoport összes értesítésére vonatkozik.',

  'snooze.datePicker.timePickerLabel': 'Idő',
  'snooze.datePicker.apply': 'Alkalmaz',
  'snooze.datePicker.cancel': 'Mégse',

  'snooze.options.anHourFromNow': 'Egy óra múlva',
  'snooze.options.inOneDay': 'Holnap',
  'snooze.options.inOneWeek': 'Jövő héten',
  'snooze.options.customTime': 'Egyéni időpont...',
  'snooze.datePicker.pastDateTooltip':
    'A kiválasztott időpontnak legalább 3 perccel a jövőben kell lennie',
  'snooze.datePicker.noDateSelectedTooltip': 'Kérjük, válasszon dátumot',
  'snooze.datePicker.exceedingLimitTooltip': ({ days }: { days: number }) =>
    `A kiválasztott időpont nem lehet több mint ${days === 1 ? '24 óra' : `${days} nap`} múlva`,

  'subscription.subscribe': 'Feliratkozás',
  'subscription.unsubscribe': 'Leiratkozás',
  'subscription.preferences.header': 'Feliratkozás kezelése',
  'subscription.preferences.headerInfo':
    'Kezelje, hogy mely frissítéseket szeretné megkapni. Megjegyzés: A munkafolyamat- és globális beállítások szabályozzák a kézbesítést, és elsőbbséget élveznek kikapcsolt állapotban.',
  'subscription.preferences.notSubscribed.header': 'Nincs feliratkozva.',
  'subscription.preferences.notSubscribed.description':
    'Iratkozzon fel az új tevékenységekről szóló értesítések fogadásához.',
  'subscription.preferences.empty.header': 'Fel van iratkozva.',
  'subscription.preferences.empty.description':
    'Jelenleg nincs kezelhető beállítás.',
};

export const localization_ro = {
  'inbox.filters.dropdownOptions.unread': 'Doar necitite',
  'inbox.filters.dropdownOptions.default': 'Necitite și citite',
  'inbox.filters.dropdownOptions.archived': 'Arhivate',
  'inbox.filters.dropdownOptions.snoozed': 'Amânate',
  'inbox.filters.labels.unread': 'Necitite',
  'inbox.filters.labels.default': 'Inbox',
  'inbox.filters.labels.archived': 'Arhivate',
  'inbox.filters.labels.snoozed': 'Amânate',

  'notifications.emptyNotice': 'Liniște momentan. Verifică din nou mai târziu.',
  'notifications.actions.readAll': 'Marchează toate ca citite',
  'notifications.actions.archiveAll': 'Arhivează toate',
  'notifications.actions.archiveRead': 'Arhivează cele citite',
  'notifications.newNotifications': ({
    notificationCount,
  }: {
    notificationCount: number;
  }) => `${notificationCount} notificări noi`,

  'notification.actions.read.tooltip': 'Marchează ca citită',
  'notification.actions.unread.tooltip': 'Marchează ca necitită',
  'notification.actions.archive.tooltip': 'Arhivează',
  'notification.actions.unarchive.tooltip': 'Dezarhivează',
  'notification.actions.snooze.tooltip': 'Amână',
  'notification.actions.unsnooze.tooltip': 'Anulează amânarea',

  'notification.snoozedUntil': 'Amânată până la',
  'preferences.title': 'Preferințe',
  'preferences.emptyNotice':
    'Nu există încă preferințe specifice notificărilor.',
  'preferences.global': 'Preferințe globale',
  'preferences.schedule.title': 'Program',
  'preferences.schedule.description': 'Permite notificări între:',
  'preferences.schedule.headerInfo':
    'Setează programul. Notificările către canalele externe vor fi oprite în afara programului. Notificările din aplicație și cele critice sunt livrate întotdeauna.',
  'preferences.schedule.info':
    'Notificările critice și cele din aplicație ajung și în afara programului.',
  'preferences.schedule.days': 'Zile',
  'preferences.schedule.from': 'De la',
  'preferences.schedule.to': 'Până la',
  'preferences.schedule.copyTimesTo': 'Copiază orele la',
  'preferences.schedule.sunday': 'Duminică',
  'preferences.schedule.monday': 'Luni',
  'preferences.schedule.tuesday': 'Marți',
  'preferences.schedule.wednesday': 'Miercuri',
  'preferences.schedule.thursday': 'Joi',
  'preferences.schedule.friday': 'Vineri',
  'preferences.schedule.saturday': 'Sâmbătă',
  'preferences.schedule.dayScheduleCopy.title': 'Copiază orele la:',
  'preferences.schedule.dayScheduleCopy.selectAll': 'Selectează tot',
  'preferences.schedule.dayScheduleCopy.apply': 'Aplică',

  'preferences.workflow.disabled.notice':
    'Contactează administratorul pentru a activa gestionarea abonamentelor pentru această notificare critică.',
  'preferences.workflow.disabled.tooltip':
    'Contactează administratorul pentru editare',
  'preferences.group.info': 'Se aplică tuturor notificărilor din acest grup.',

  'snooze.datePicker.timePickerLabel': 'Ora',
  'snooze.datePicker.apply': 'Aplică',
  'snooze.datePicker.cancel': 'Anulează',

  'snooze.options.anHourFromNow': 'Peste o oră',
  'snooze.options.inOneDay': 'Mâine',
  'snooze.options.inOneWeek': 'Săptămâna viitoare',
  'snooze.options.customTime': 'Oră personalizată...',
  'snooze.datePicker.pastDateTooltip':
    'Ora selectată trebuie să fie cu cel puțin 3 minute în viitor',
  'snooze.datePicker.noDateSelectedTooltip': 'Selectează o dată',
  'snooze.datePicker.exceedingLimitTooltip': ({ days }: { days: number }) =>
    `Ora selectată nu poate depăși ${days === 1 ? '24 de ore' : `${days} zile`} de acum`,

  'subscription.subscribe': 'Abonează-te',
  'subscription.unsubscribe': 'Dezabonează-te',
  'subscription.preferences.header': 'Gestionează abonamentul',
  'subscription.preferences.headerInfo':
    'Gestionează actualizările pe care dorești să le primești. Notă: Setările fluxului și cele globale controlează livrarea și au prioritate când sunt dezactivate.',
  'subscription.preferences.notSubscribed.header': 'Nu ești abonat.',
  'subscription.preferences.notSubscribed.description':
    'Abonează-te pentru a primi actualizări despre activități noi.',
  'subscription.preferences.empty.header': 'Ești abonat.',
  'subscription.preferences.empty.description':
    'Nu există nimic de gestionat momentan.',
};

export const localization_de = {
  'inbox.filters.dropdownOptions.unread': 'Nur ungelesene',
  'inbox.filters.dropdownOptions.default': 'Ungelesene & gelesene',
  'inbox.filters.dropdownOptions.archived': 'Archivierte',
  'inbox.filters.dropdownOptions.snoozed': 'Zurückgestellte',
  'inbox.filters.labels.unread': 'Ungelesen',
  'inbox.filters.labels.default': 'Posteingang',
  'inbox.filters.labels.archived': 'Archiviert',
  'inbox.filters.labels.snoozed': 'Zurückgestellt',

  'notifications.emptyNotice':
    'Momentan ist es ruhig. Schau später wieder vorbei.',
  'notifications.actions.readAll': 'Alle als gelesen markieren',
  'notifications.actions.archiveAll': 'Alle archivieren',
  'notifications.actions.archiveRead': 'Gelesene archivieren',
  'notifications.newNotifications': ({
    notificationCount,
  }: {
    notificationCount: number;
  }) => `${notificationCount} neue Benachrichtigung(en)`,

  'notification.actions.read.tooltip': 'Als gelesen markieren',
  'notification.actions.unread.tooltip': 'Als ungelesen markieren',
  'notification.actions.archive.tooltip': 'Archivieren',
  'notification.actions.unarchive.tooltip': 'Archivierung aufheben',
  'notification.actions.snooze.tooltip': 'Zurückstellen',
  'notification.actions.unsnooze.tooltip': 'Zurückstellung aufheben',

  'notification.snoozedUntil': 'Zurückgestellt bis',
  'preferences.title': 'Einstellungen',
  'preferences.emptyNotice':
    'Noch keine benachrichtigungsspezifischen Einstellungen vorhanden.',
  'preferences.global': 'Globale Einstellungen',
  'preferences.schedule.title': 'Zeitplan',
  'preferences.schedule.description': 'Benachrichtigungen erlauben zwischen:',
  'preferences.schedule.headerInfo':
    'Legen Sie Ihren Zeitplan fest. Benachrichtigungen über externe Kanäle werden außerhalb des Zeitplans pausiert. In-App- und kritische Benachrichtigungen werden immer zugestellt.',
  'preferences.schedule.info':
    'Kritische und In-App-Benachrichtigungen erreichen Sie auch außerhalb Ihres Zeitplans.',
  'preferences.schedule.days': 'Tage',
  'preferences.schedule.from': 'Von',
  'preferences.schedule.to': 'Bis',
  'preferences.schedule.copyTimesTo': 'Zeiten kopieren nach',
  'preferences.schedule.sunday': 'Sonntag',
  'preferences.schedule.monday': 'Montag',
  'preferences.schedule.tuesday': 'Dienstag',
  'preferences.schedule.wednesday': 'Mittwoch',
  'preferences.schedule.thursday': 'Donnerstag',
  'preferences.schedule.friday': 'Freitag',
  'preferences.schedule.saturday': 'Samstag',
  'preferences.schedule.dayScheduleCopy.title': 'Zeiten kopieren nach:',
  'preferences.schedule.dayScheduleCopy.selectAll': 'Alle auswählen',
  'preferences.schedule.dayScheduleCopy.apply': 'Anwenden',

  'preferences.workflow.disabled.notice':
    'Kontaktieren Sie den Administrator, um die Abonnementverwaltung für diese kritische Benachrichtigung zu aktivieren.',
  'preferences.workflow.disabled.tooltip':
    'Kontaktieren Sie den Administrator zum Bearbeiten',
  'preferences.group.info': 'Gilt für alle Benachrichtigungen dieser Gruppe.',

  'snooze.datePicker.timePickerLabel': 'Uhrzeit',
  'snooze.datePicker.apply': 'Anwenden',
  'snooze.datePicker.cancel': 'Abbrechen',

  'snooze.options.anHourFromNow': 'In einer Stunde',
  'snooze.options.inOneDay': 'Morgen',
  'snooze.options.inOneWeek': 'Nächste Woche',
  'snooze.options.customTime': 'Benutzerdefinierte Zeit...',
  'snooze.datePicker.pastDateTooltip':
    'Die ausgewählte Zeit muss mindestens 3 Minuten in der Zukunft liegen',
  'snooze.datePicker.noDateSelectedTooltip': 'Bitte wählen Sie ein Datum aus',
  'snooze.datePicker.exceedingLimitTooltip': ({ days }: { days: number }) =>
    `Die ausgewählte Zeit darf nicht mehr als ${days === 1 ? '24 Stunden' : `${days} Tage`} von jetzt an entfernt sein`,

  'subscription.subscribe': 'Abonnieren',
  'subscription.unsubscribe': 'Abbestellen',
  'subscription.preferences.header': 'Abonnement verwalten',
  'subscription.preferences.headerInfo':
    'Verwalten Sie, welche Updates Sie erhalten möchten. Hinweis: Workflow- und globale Einstellungen steuern die Zustellung und haben Vorrang, wenn sie deaktiviert sind.',
  'subscription.preferences.notSubscribed.header': 'Sie sind nicht abonniert.',
  'subscription.preferences.notSubscribed.description':
    'Abonnieren Sie, um Updates über neue Aktivitäten zu erhalten.',
  'subscription.preferences.empty.header': 'Sie sind abonniert.',
  'subscription.preferences.empty.description':
    'Momentan gibt es nichts zu verwalten.',
};
